import NextButton from 'crazyEditor/components/Toolbar/GlobalControls/NextButton/NextButton';
/* global window, moeditor, Intercom */
import PropTypes from 'prop-types';

import React, { Component, Fragment } from 'react';
import SvgIcon from 'material-ui/SvgIcon';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import {Toolbar, ToolbarGroup, ToolbarTitle, ToolbarSeparator} from 'material-ui/Toolbar';
import ViewModes from './ViewModes/ViewModes';
import { undoActionElement, redoActionElement } from 'crazyEditor/redux/modules/element/actions/generalActions';
import { EDITOR_MODES, VIEW_MODES, PREVIEW_BUTTON_ID, EDITOR_UNDO_REDO_BUTTONS_ID } from 'crazyEditor/core/constants/editorConstants';
import { GLOBAL_CONTROLS } from 'crazyEditor/core/constants/editorConstants';
import _ from 'lodash';
import SaveButtons from './SaveButtons/SaveButtons';
import HelpButton from './HelpButton/HelpButton';
import * as Colors from 'material-ui/styles/colors';
import { TYPES, EDITOR_PANELS } from 'crazyEditor/core/constants/panelConstants';
import shallowEqual from 'fbjs/lib/shallowEqual';
import { Link } from 'react-router';
import * as routes from 'App/routeConstants';
import {onHomeClicked} from 'shared/components/Integration/IntegrationUtils';
import { leftArrow } from 'shared/icons';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import {openPublishDialog} from 'crazyEditor/redux/modules/publishDialog/publishDialog';
import {setEditorMode, setViewModeInEditor} from 'crazyEditor/core/utils/stageUtils';
import { getPreviousActionViewMode, getNextActionViewMode } from 'crazyEditor/redux/modules/element/elementSelectors';
import {isDraft} from 'crazyEditor/redux/modules/element/elementSelectors';
import {fade} from 'material-ui/utils/colorManipulator';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
const styles = require('./GlobalControlsStyles');
const classes = require('./GlobalControls.scss');

@connectWithRouter(
  (state) => ({
    isQuickPreviewMode: state.editor.isQuickPreviewMode,
    isPreviewMode: state.editor.isPreviewMode,
    isEditorMode: state.editor.isEditorMode,
    ebayConnected: !_.isEmpty(state.accountPage.accounts),
    publishAction: state.user.planDetails.publishAction,
    button: state.routing.location.query.button,
    firstTime: !!state.routing.location.query.start_trial,
    backTo: state.routing.location.query.backTo,
    query: state.routing.location.query,
    bulkReviseEnabled: state.user.bulkReviseEnabled,
    templateName: state.template.editable && state.template.name,
    listingTitle: state.listingData && state.listingData.ebayTitle,
    viewMode: state.editor.viewMode,
    previousActionViewMode: getPreviousActionViewMode(state),
    nextActionViewMode: getNextActionViewMode(state),
    draft: isDraft(state),
  }), {
    undoActionElement,
    redoActionElement,
    openLazyPanel,
    openPublishDialog,
  }
)
export default class GlobalControls extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    integrationConnector: PropTypes.object,
    utils: PropTypes.object.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
  }

  onHomeClicked = () => {
    if (this.context.integrationConnector.isIntegrationEnabled()) {
      onHomeClicked(this.context.integrationConnector);
    } else {
      this.context.router.goBack();
    }
  };

  setPreviewMode = () => {
    setEditorMode(EDITOR_MODES.PREVIEW);
  };

  backToEditor = () => {
    setEditorMode(EDITOR_MODES.EDITOR);
  };

  handlePublishClicked = () => {
    const {openPublishDialog} = this.props;
    this.context.utils.verifyUserStatusAndCall(() => {
      openPublishDialog();
    });
  };

  render() {
    const {draft, query, backTo, firstTime, isQuickPreviewMode, isPreviewMode, isEditorMode, undoActionElement, redoActionElement, bulkReviseEnabled, templateName, listingTitle, viewMode, previousActionViewMode, nextActionViewMode} = this.props;
    const integrationEnabled = this.context.integrationConnector.isIntegrationEnabled();

    let link;
    let backButtonLabel;
    let onClick;
    if (firstTime) {
      link = <Link to={{pathname: routes.MyAccount.ViewDesigns}} />;
      backButtonLabel = 'Pick A Theme';
    } else {
      backButtonLabel = 'Back';
      if (backTo && !isQuickPreviewMode) {
        link = <Link to={{pathname: backTo, query: _.omit(query, ['id', 'template_copy_id', 'itemId'])}}/>;
      } else {
        onClick = this.onHomeClicked;
      }
    }
    return (
      <Toolbar id={GLOBAL_CONTROLS} noGutter>
        <ToolbarGroup style={{maxWidth: `calc(50% - ${isPreviewMode ? 220 : 100}px)`}}>
          <FlatButton label={backButtonLabel}
                      labelPosition="after"
                      secondary {...styles.buttonProperties}
                      labelStyle={{paddingLeft: '10px', verticalAlign: 'initial'}}
                      style={styles.buttonStyle}
                      containerElement={!integrationEnabled && link ? link : undefined}
                      onClick={onClick}
                      icon={
                        <SvgIcon style={{marginBottom: '4px'}}>
                          <path fill="#fff" d={leftArrow} />
                        </SvgIcon>}
          />
          <ToolbarSeparator style={styles.separatorStyle}/>
          {
            !isQuickPreviewMode &&
            <i className={isPreviewMode ? classes.hideOnSmallScreen : undefined} style={{color: Colors.white, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingLeft: 40, paddingRight: 10}}>
              {listingTitle || templateName || 'Untitled'}
              {
                draft && ' (Draft)'
              }
            </i>
          }
        </ToolbarGroup>

        <ToolbarGroup style={styles.centeredControls}>
          <span key={2} style={{position: 'relative', display: 'inline-flex', }}>
            <ToolbarSeparator style={styles.separatorStyle}/>
            <ViewModes />
            <ToolbarSeparator style={_.assign({}, styles.separatorStyle, {marginRight: '12px'})}/>
          </span>
          { isPreviewMode && !isQuickPreviewMode && <span style={styles.previewModeText}>You are currently in preview mode</span>}
        </ToolbarGroup>
        <ToolbarGroup>
          <ToolbarSeparator style={styles.separatorStyle}/>
          {
            isEditorMode ?
              [
                <HelpButton key="1"/>,
                <div key="2" id={EDITOR_UNDO_REDO_BUTTONS_ID} style={{display: 'flex'}}>
                  <FlatButton style={styles.buttonStyle}
                              key="2"
                              onClick={() => {
                                if (previousActionViewMode && viewMode !== previousActionViewMode) {
                                  setViewModeInEditor(previousActionViewMode, previousActionViewMode === VIEW_MODES.MOBILE);
                                } else {
                                  undoActionElement();
                                }
                              }}
                              children={<FontIcon style={styles.iconButtonStyle} className="material-icons">undo</FontIcon>}
                  />
                  <FlatButton style={styles.buttonStyle}
                              key="3"
                              onClick={() => {
                                if (nextActionViewMode && viewMode !== nextActionViewMode) {
                                  setViewModeInEditor(nextActionViewMode, nextActionViewMode === VIEW_MODES.MOBILE);
                                } else {
                                  redoActionElement();
                                }
                              }}
                              children={<FontIcon style={styles.iconButtonStyle} className="material-icons">redo</FontIcon>}
                  />
                </div>,
                <div key="3" id={PREVIEW_BUTTON_ID}>
                  <FlatButton label="Preview"
                              key="4"
                              secondary
                              {...styles.buttonProperties}
                              style={styles.buttonStyle}
                              onClick={this.setPreviewMode}
                  />
                </div>
              ]
              :
                <FlatButton label={isQuickPreviewMode ? 'edit this theme' : 'Back to Editor'}
                            onClick={this.backToEditor}
                            style={styles.buttonStyle}
                            backgroundColor={isQuickPreviewMode ? Colors.lightGreen700 : undefined}
                            hoverColor={isQuickPreviewMode ? fade(Colors.lightGreen700, 0.8) : undefined}
                />
          }
          {
            !isQuickPreviewMode &&
            <Fragment>
              <SaveButtons onExit={() => this.onHomeClicked()}/>
              <NextButton/>
            </Fragment>
          }
          {
            !isQuickPreviewMode && !bulkReviseEnabled && !integrationEnabled &&
            <FlatButton label="publish"
                        onClick={this.handlePublishClicked}
                        style={styles.buttonStyle}
                        {...styles.primaryButtonProperties}
            />
          }
        </ToolbarGroup>
      </Toolbar>
    );
  }
}